import { render, staticRenderFns } from "./multilineListItems.vue?vue&type=template&id=1963861d&scoped=true"
import script from "./multilineListItems.vue?vue&type=script&lang=js"
export * from "./multilineListItems.vue?vue&type=script&lang=js"
import style0 from "./multilineListItems.vue?vue&type=style&index=0&id=1963861d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963861d",
  null
  
)

export default component.exports